import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as VueDeepSet from 'vue-deepset'

import app from './app'
import ui from './ui'

Vue.use(Vuex)

export default new Vuex.Store({
  mutations: VueDeepSet.extendMutation(),
  modules: {
    app,
    ui
  },
  plugins: [
    createPersistedState({
      path: ['ui.general', 'ui.navDrawer']
    })
  ]
})
